import rwaAnimation from './animations/rwa.json';
import venturesAnimation from './animations/ventures.json';
import gamingAnimation from './animations/gaming.json';
import aiAnimation from './animations/ai.json';
import financeAnimation from './animations/finance.json';
import tradingAnimation from './animations/trading.json';
import {
  AILogo,
  FinanceLogo,
  GamingLogo,
  RWALogo,
  TradingLogo,
  VenturesLogo,
} from '@/icons/custom';

export const divisionItems = [
  {
    name: 'RWA',
    image: '/images/divisions/rwa.png',
    animationData: rwaAnimation,
    icon: RWALogo,
  },
  {
    name: 'Ventures',
    image: '/images/divisions/ventures.png',
    animationData: venturesAnimation,
    icon: VenturesLogo,
  },
  {
    name: 'Gaming',
    image: '/images/divisions/gaming.png',
    animationData: gamingAnimation,
    icon: GamingLogo,
  },
  {
    name: 'AI',
    image: '/images/divisions/ai.png',
    animationData: aiAnimation,
    icon: AILogo,
  },
  {
    name: 'Finance',
    image: '/images/divisions/finance.png',
    animationData: financeAnimation,
    icon: FinanceLogo,
  },
  {
    name: 'Trading',
    image: '/images/divisions/trading.png',
    animationData: tradingAnimation,
    icon: TradingLogo,
  },
];
